
export const classification_options = [
  { value: "External", label: "External" },
  { value: "Hosted", label: "Hosted" }
];
